import CustomSelectButton from './CustomSelectButton';
import CustomSelectOption from './CustomSelectOption';
import CustomSelectOptionList from './CustomSelectOptionList';
import CustomSelectRoot from './CustomSelectRoot';
import './CustomSelect.scss';
const CustomSelect = {
    Root: CustomSelectRoot,
    Button: CustomSelectButton,
    OptionList: CustomSelectOptionList,
    Option: CustomSelectOption,
};
export default CustomSelect;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tU2VsZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ3VzdG9tU2VsZWN0L0N1c3RvbVNlbGVjdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxrQkFBa0IsTUFBTSxzQkFBc0IsQ0FBQztBQUN0RCxPQUFPLGtCQUFrQixNQUFNLHNCQUFzQixDQUFDO0FBQ3RELE9BQU8sc0JBQXNCLE1BQU0sMEJBQTBCLENBQUM7QUFDOUQsT0FBTyxnQkFBZ0IsTUFBTSxvQkFBb0IsQ0FBQztBQUdsRCxPQUFPLHFCQUFxQixDQUFDO0FBRTdCLE1BQU0sWUFBWSxHQUE0QjtJQUMxQyxJQUFJLEVBQUUsZ0JBQWdCO0lBQ3RCLE1BQU0sRUFBRSxrQkFBa0I7SUFDMUIsVUFBVSxFQUFFLHNCQUFzQjtJQUNsQyxNQUFNLEVBQUUsa0JBQWtCO0NBQzdCLENBQUM7QUFFRixlQUFlLFlBQVksQ0FBQyJ9